/* FAETTON FINAL POLISH V4 — loaded last; fixes sticky, scroll jump, and perceived first fold */
(function(){
  'use strict';
  var doc = document;
  var win = window;
  var isMobile = function(){ return win.matchMedia && win.matchMedia('(max-width: 767px)').matches; };
  var userInteracted = false;
  var allowProgrammaticScrollUntil = Date.now() + 2200;

  function markInteraction(){ userInteracted = true; allowProgrammaticScrollUntil = 0; }
  ['touchstart','touchmove','wheel','keydown','mousedown','pointerdown'].forEach(function(evt){
    win.addEventListener(evt, markInteraction, {passive:true, capture:true});
  });

  /* Some legacy scripts scroll to pagecontent/top while PDP is still booting. On mobile this feels like a forced jump.
     Block only early top-scroll attempts, and never block user-originated scrolling. */
  try {
    var nativeScrollTo = win.scrollTo.bind(win);
    var nativeScrollBy = win.scrollBy.bind(win);
    function wantsTop(args){
      if(!args || !args.length) return false;
      if(typeof args[0] === 'object' && args[0]) return (args[0].top || 0) <= 4;
      return (args[1] || 0) <= 4;
    }
    win.scrollTo = function(){
      if(isMobile() && !userInteracted && Date.now() < allowProgrammaticScrollUntil && wantsTop(arguments) && win.pageYOffset > 40){
        return;
      }
      return nativeScrollTo.apply(win, arguments);
    };
    win.scrollBy = function(){
      if(isMobile() && !userInteracted && Date.now() < allowProgrammaticScrollUntil && wantsTop(arguments) && win.pageYOffset > 40){
        return;
      }
      return nativeScrollBy.apply(win, arguments);
    };
  } catch(e) {}

  function visibleEnough(el, threshold){
    if(!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    var vh = win.innerHeight || doc.documentElement.clientHeight || 0;
    var vw = win.innerWidth || doc.documentElement.clientWidth || 0;
    if(r.width <= 1 || r.height <= 1) return false;
    if(r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) return false;
    var visibleH = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return visibleH >= Math.min(r.height * (threshold || 0.2), 56);
  }

  function findMainATC(){
    var selectors = [
      '.main-atc-form button[name="add"]',
      'form[action*="/cart/add"] button[name="add"]',
      '.purchase-details__buttons button[name="add"]',
      'button.ajax-submit.action_button.add_to_cart:not(#sticky button):not(#sticky2 button)',
      'a.ajax-submit.action_button.add_to_cart:not(#sticky a):not(#sticky2 a)'
    ];
    for(var i=0;i<selectors.length;i++){
      var list = doc.querySelectorAll(selectors[i]);
      for(var j=0;j<list.length;j++){
        var el = list[j];
        if(el && !el.closest('#sticky,#sticky2,.ajax-cart,.ajax-cart__drawer,.product-popup,.prod_flyout-radous') && el.offsetParent !== null) return el;
      }
    }
    return null;
  }

  function findGetLookCTA(){
    var selectors = [
      '.custom-btn-price:not(.hide-div)',
      '.custom-btn-price:not(.hide-div) button:not([disabled])',
      '.carousel--get-the-look .custom-btn-price:not(.hide-div)',
      '.cross-sells .custom-btn-price:not(.hide-div)',
      '.cross-sells-container .custom-btn-price:not(.hide-div)'
    ];
    for(var i=0;i<selectors.length;i++){
      var el = doc.querySelector(selectors[i]);
      if(el) return el.closest('.custom-btn-price') || el;
    }
    return null;
  }

  function setClass(name, on){ doc.body && doc.body.classList.toggle(name, !!on); }
  function setSticky(sticky, on){
    if(!sticky) return;
    sticky.classList.toggle('show', !!on);
    if(sticky.id === 'sticky2') sticky.classList.toggle('faetton-mobile-sticky-visible', !!on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function evaluateSticky(){
    if(!doc.body || !isMobile()) return;
    var main = findMainATC();
    var getLook = findGetLookCTA();
    var mainVisible = visibleEnough(main, 0.15);
    var getLookVisible = visibleEnough(getLook, 0.2);
    setClass('faetton-main-atc-visible', mainVisible);
    setClass('faetton-getlook-visible', getLookVisible);

    var passedMain = main ? (main.getBoundingClientRect().bottom <= 0) : false;
    var allowed = !!(passedMain && !mainVisible && !getLookVisible && win.pageYOffset > Math.max(280, (win.innerHeight || 0) * 0.55));
    doc.querySelectorAll('#sticky,#sticky2').forEach(function(sticky){ setSticky(sticky, allowed); });
  }

  var raf = 0;
  function schedule(){
    if(raf) return;
    raf = win.requestAnimationFrame(function(){ raf = 0; evaluateSticky(); });
  }

  function boot(){
    schedule();
    win.addEventListener('scroll', schedule, {passive:true});
    win.addEventListener('resize', schedule, {passive:true});
    try{
      new MutationObserver(schedule).observe(doc.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','disabled','hidden','aria-hidden']});
    }catch(e){}
    setTimeout(schedule, 250);
    setTimeout(schedule, 900);
    setTimeout(schedule, 1800);
  }

  if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();

  /* Stronger safe prefetch: no DOM swap, no app breakage. */
  var seen = window.FaettonPrefetched || (window.FaettonPrefetched = Object.create(null));
  function normalize(url){ try{return new URL(url, location.href);}catch(e){return null;} }
  function safeProduct(url){
    var u = normalize(url); if(!u || u.origin !== location.origin) return false;
    if(!/\/products\//.test(u.pathname)) return false;
    if(/\/cart|\/checkout|\/account|\/admin|\/apps|\/search/.test(u.pathname)) return false;
    if(/(^|[?&])variant=/.test(u.search)) return false;
    return u.href.split('#')[0];
  }
  function prefetch(url, pri){
    var key = safeProduct(url); if(!key || seen[key]) return; seen[key] = true;
    try{
      var l = doc.createElement('link'); l.rel = 'prefetch'; l.as = 'document'; l.href = key; if(pri) l.fetchPriority = pri; doc.head.appendChild(l);
    }catch(e){}
  }
  doc.addEventListener('pointerover', function(e){ var a=e.target.closest&&e.target.closest('a[href*="/products/"]'); if(a) prefetch(a.href, 'high'); }, {passive:true});
  doc.addEventListener('touchstart', function(e){ var a=e.target.closest&&e.target.closest('a[href*="/products/"]'); if(a) prefetch(a.href, 'high'); }, {passive:true});
  doc.addEventListener('pointerdown', function(e){ var a=e.target.closest&&e.target.closest('a[href*="/products/"]'); if(a) prefetch(a.href, 'high'); }, {passive:true});
})();
